"use client";
import { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

export type GDPRContextState = {
  gdprAgreed: boolean;
  setGdprAgreed: Dispatch<SetStateAction<boolean>>;
  termsAndConditionsAgreed: boolean;
  setTermsAndConditionsAgreed: Dispatch<SetStateAction<boolean>>;
};

export const GDPRContext = createContext<GDPRContextState>({
  gdprAgreed: false, // Used to skip agreements page when gdpr already agreed
  setGdprAgreed: () => {},
  termsAndConditionsAgreed: false,
  setTermsAndConditionsAgreed: () => {},
});
